import React from 'react';
import PropTypes from 'prop-types';

import SelectStyled from './SelectStyled';
import SelectWrapper from './SelectWrapper';

class Select extends React.PureComponent {
  render() {
    return (
      <SelectWrapper>
        <SelectStyled
          onChange={this.props.onChange}
          value={this.props.value}
          id={this.props.id}
          disabled={this.props.disabled}
          style={this.props.style}
        >
          {this.props.children}
        </SelectStyled>
      </SelectWrapper>
    );
  }
}

Select.propTypes = {
  children: PropTypes.node,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.shape(),
};

Select.defaultProps = {
  children: null,
  onChange: () => {},
  value: '',
  id: undefined,
  disabled: false,
  style: undefined,
};

export default Select;
